import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const Modal = ({ open, onClose, children, wide = false, testId = "modal" }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
  <AnimatePresence>
    {open && (
      <motion.div
        className="fixed inset-0 z-[100] flex items-start md:items-center justify-center p-4 md:p-8 bg-[#0B1B2B]/80 backdrop-blur-sm overflow-y-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onMouseDown={(e) => e.target === e.currentTarget && onClose()}
        data-testid={`${testId}-overlay`}
      >
        <motion.div
          className={`relative w-full ${wide ? "max-w-3xl" : "max-w-xl"} bg-white border border-[#D4AF37]/30 shadow-2xl rounded-xl my-8`}
          initial={{ opacity: 0, y: 24, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.98 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          data-testid={testId}
          role="dialog"
          aria-modal="true"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 p-2 rounded-full text-[#64748B] hover:text-[#0B1B2B] hover:bg-[#F8FAFC] transition-colors"
            data-testid={`${testId}-close-button`}
            aria-label="Close"
          >
            <X size={18} />
          </button>
          {children}
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
  );
};
